import { useRef, useLayoutEffect } from 'react';

/**
 * Custom hook that returns a ref with the latest value.
 * Useful for avoiding stale closures in callbacks.
 */
export function useLatest<T>(value: T) {
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
}
